import React from 'react';

import KeyChip from '@dashboard/components/KeyChip';
import { useWorkflowEventQuery, WorkflowEventSource } from '@dashboard/generated/wp/platform';

import { DateFormatter } from '@waypoint/react/formatters';

type Props = {
  id: string;
};
export default function CardCaption({ id }: Props) {
  const { data } = useWorkflowEventQuery({ variables: { id } });

  const model = data?.WorkflowEvent;
  if (model === undefined) {
    return null;
  }

  switch (model.source) {
    case WorkflowEventSource.Preview:
      return (
        <>
          Workflow triggered on <DateFormatter template="full" value={model.createdAt} /> from the workflow builder
          page.
        </>
      );
    case WorkflowEventSource.Api:
    case WorkflowEventSource.Trigger:
      if (model.workflowKey) {
        return (
          <>
            Workflow triggered on <DateFormatter template="full" value={model.createdAt} /> from the API using custom
            key <KeyChip label={model.workflowKey} />.
          </>
        );
      }
      return (
        <>
          Workflow triggered on <DateFormatter template="full" value={model.createdAt} /> from the API
        </>
      );
  }

  return (
    <>
      Workflow triggered on <DateFormatter template="full" value={model.createdAt} />.
    </>
  );
}
